import p5 from "p5"

const printWidth = 12
const printHeight = 12
const printDpi = 300

const renderWidth = printWidth * printDpi
const renderHeight = printHeight * printDpi
let rendering = false
var output :p5.Graphics


const res = 8 + Math.floor(fxrand() * 5) * 4
// const res = 24
const moves :p5.Vector[] = [
  new p5.Vector( 2,  1),
  new p5.Vector( 1,  2),
  new p5.Vector(-1,  2),
  new p5.Vector(-2,  1),
  new p5.Vector(-2, -1),
  new p5.Vector(-1, -2),
  new p5.Vector( 1, -2),
  new p5.Vector( 2, -1),
]
let board = Array.from(
  { length: res + 4 },
  () => Array.from({ length: res + 4 }, () => 0)
)
let tour :p5.Vector[]
let hue1 = fxrand()
let hue2 = fxrand()

let current :p5.Vector
let current_index = 0

let closed_tour = false
let rand_offset = 0.0


let get_variance = () => {
  var variance = Math.abs(hue2 - hue1)
  if (variance >= 0.85)      return "Very High"
  else if (variance >= 0.65) return "High"
  else if (variance >= 0.35) return "Medium"
  else                       return "Low"
}

window.$fxhashFeatures = {
  "Board Resolution": `${res}x${res}`,
  "Color Variance": `${get_variance()}`,
}


let s = (sk :p5) => {
  let size = sk.min(sk.windowWidth, sk.windowHeight)
  
  sk.setup = () => {
    sk.createCanvas(size, size)
    sk.colorMode(sk.HSB, 1)
    sk.noStroke()
    sk.background(1.0)

    output = sk.createGraphics(renderWidth, renderHeight)
    output.colorMode(sk.HSB, 1)
    output.noStroke()
    output.background(1.0)

    reset()
    build_tour()
    console.log(window.$fxhashFeatures)
  }
  
  
  sk.draw = () => {
    if (tour.length > 0) {
      const target = rendering ? output : sk

      const first = tour[0]
      const last = tour[tour.length - 1]
      
      const w = target.width / (res + 2.0)
      const h = target.height / (res + 2.0)
      
      if (closed_tour) {
        if (current_index < tour.length) {
          const nb_steps = 1200
          const dx = 0.2 * size / res
          const dy = -dx * 0.1
          const slant = dx * 1.0
          
          // draw tour's lines
          target.beginShape()
          
          for (let i = current_index; i < current_index + 1 && i < tour.length; i++) {
            const v1 = tour[get_index(i-1)]
            const v2 = tour[get_index(i)]
            const v3 = tour[get_index(i+1)]
            const v4 = tour[get_index(i+2)]
            
            for (let k = 0; k < nb_steps; k++) {
              let t = sk.map(current_index, 0, tour.length, 0, 1)
              
              let hue = target.lerp(hue1, hue2, Math.cos(t * target.TAU) * 0.5 + 0.5)
              let brightness = target.map(Math.cos(t * target.TAU * 2), -1, 1, 0.4, 0.9)
              
              target.fill(hue, 0.7, brightness, 0.1)
              
              const x = target.curvePoint(v1.x, v2.x, v3.x, v4.x, k / nb_steps) - 0.5
              const y = target.curvePoint(v1.y, v2.y, v3.y, v4.y, k / nb_steps) - 0.5
              
              target.quad(
                  x * w - dx * 0.5, y * h - (dy - slant) * 0.5,
                  x * w + dx * 0.5, y * h - (dy + slant) * 0.5,
                  x * w + dx * 0.5, y * h + (dy - slant) * 0.5,
                  x * w - dx * 0.5, y * h + (dy + slant) * 0.5
              )
            }
          }
          
          target.endShape()
          current_index += 1
        } else {
          if (rendering) {
            output.save(fxhash + "-hires.png");
          } else {
            window.fxpreview()
          }
          sk.noLoop()
        }
      
      } else {
        moves.forEach((move) => {
          const next = last.copy().add(move)
          if (next.x == first.x && next.y == first.y) {
            closed_tour = true
          }
        })

        if (!closed_tour) {
          reset()
          build_tour()
        }
      }
    }
  }

  sk.keyTyped = () => {
    switch (sk.key) {
      case 's':
        size = Math.min(renderWidth, renderHeight)
        current_index = 0
        rendering = true
        sk.loop()
        break
    }
  }
}


let build_tour = () => {
  while (tour.length < res * res) {
    let minW = 8
    let next = current.copy()

    let indices :number[] = []
    for (let i = 0; i < moves.length; i++) {
      indices.push(i)
    }
    indices.sort(() => fxrand() - 0.5 + rand_offset)

    indices.forEach((i) => {
      let move = moves[i]
      let pos = current.copy().add(move)
      let cell = board[Math.floor(pos.x)][Math.floor(pos.y)]
      if (cell == 0) {
        let warnsdorff = heuristic(pos)
        if (warnsdorff < minW) {
          minW = warnsdorff
          next = pos.copy()
        }
      }
    })

    if (current.equals(next)) { // UNFINISHED TOUR GLITCH PREVENTION
      rand_offset = (rand_offset + fxrand()) * 0.5
      reset()
    } else {
      current = next
      current_index = 0
      tour.push(current)
      board[Math.floor(current.x)][Math.floor(current.y)] = tour.length
    }
  }

  closed_tour = false
}


let reset = () => {
  for (let i = 0; i < res + 4; i++) {
    for (let j = 0; j < res + 4; j++) {
      board[i][j] = (i > 1 && i < res + 2 && j > 1 && j < res + 2) ? 0 : -1;
    }
  }

  tour = []

  current = new p5.Vector(
    2 + Math.floor(fxrand() * (res - 4)),
    2 + Math.floor(fxrand() * (res - 4))
  )
}


let heuristic = (target :p5.Vector) :number => {
  let count = 0

  moves.forEach((move) => {
    let next = target.copy().add(move)
    let cell = board[Math.floor(next.x)][Math.floor(next.y)]
    if (cell == 0) count++
  })

  return count
}


let get_index = (index :number) => {
  return (index + tour.length) % tour.length;
}


new p5(s)
